<!--
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-05-29 09:33:08
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\components\filterList.vue
-->
<template>
    <div :class="{filter:!isMobile,mfilter:isMobile}">
        <el-collapse class="fils" :class="popperClass" v-model="activeValue" @change="handleChange">
            <el-collapse-item name="detail">
                <template slot="title">
                    <div class="key">{{ title }}</div>
                    <!--                   {{title}}-->
                    <div class="switch">{{ isOpen ? '-' : '+' }}</div>
                </template>
                <div>
                    <slot></slot>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    name: "filterList",
    props: {
        title: String,
        isOpen: {
            type: Boolean,
            default: false,
        },
        popperClass: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            activeValue: [],
        }
    },
    mounted() {
        this.activeValue = this.isOpen ? ['detail'] : [];
    },
    methods: {
        check() {
            console.log('init')
        },
        handleChange(val) {
            this.isOpen = val.length !== 0;
        }
    }
}
</script>

<style scoped lang="less">
.filter {
    .key {
        font-size: 14px;
        line-height: 24px;
    }
}

.mfilter {
    .key {
        font-size: 10pt;
    }
}

</style>
